import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import MatrikkelSearchEvents from '../MatrikkelSearchEvents.js'
import AdresseIcon from '../../../images/Adresse_white.png'

class Adresse extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }
   
    toggleAdresse = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    showAdresse = (event) => {
        event.stopPropagation()
        this.props.onEvent({
            type: MatrikkelSearchEvents.ShowObject,
            data: {
                type: MatrikkelSearchEvents.ShowAdresse,
                adresse: this.props.adresse
            }
        })
    }

    render() {
        const { t } = this.props
        var adresse = this.props.adresse
        var title = `${adresse.adressekode||''} ${adresse.adressenavn||''} ${adresse.nummer||''}${adresse.bokstav||''}`.trim() || adresse.adressetilleggsnavn || adresse.domeneklasse
        var kommune = adresse.kommuneId ? `${adresse.kommunenavn} (${adresse.kommuneId})` : null        
        return (
            <li>
                <div className="section-header mainsection" onClick={this.toggleAdresse}>
                    <div className="icon-image"><img src={AdresseIcon} /></div>
                    <span className="title">{title}</span>
                    <span className="icon right"><i className={`fa fa-${this.state.isOpened ? 'minus' : 'plus'}-circle`}></i></span>
                    <div className="icon right tooltip" onClick={this.showAdresse}><i className="fa fa-map-marker-alt"></i>
                        <div className="tooltip-content">{t('vis.adresse')}</div>
                    </div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('adressetilleggsnavn')}</div>
                            <div className="value">{adresse.adressetilleggsnavn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('kortnavn')}</div>
                            <div className="value">{adresse.kortnavn}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('nummer')}</div>
                            <div className="value">{adresse.nummer}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('undernummer')}</div>
                            <div className="value">{adresse.undernummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bokstav')}</div>
                            <div className="value">{adresse.bokstav}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('kommune')}</div>
                            <div className="value">{kommune}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('adressekode')}</div>
                            <div className="value">{adresse.adressekode}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('adressenavn')}</div>
                            <div className="value">{adresse.adressenavn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('kortadressenavn')}</div>
                            <div className="value">{adresse.kortAdressenavn}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('kortadressenavn')}</div>
                            <div className="value">{adresse.kortAdressenavn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('adressetype')}</div>
                            <div className="value">{adresse.domeneklasse}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Adresse)